import type { ObjectPropertyNameMatcher } from '@noths/polaris-client-utils';
import { cloneObjectWithCollapsingProperties } from '@noths/polaris-client-utils';
import type { IncomingMessage } from 'http';

import { FEATURE_FLAGS_HTTP_HEADER_NAME, FLAG_DELIMITER } from './constants';
import { parseFeatureFlagsString } from './parseFeatureFlagsString';

const getFlagsHttpHeaderValue = (req: IncomingMessage) => {
  const headerValue = req.headers[FEATURE_FLAGS_HTTP_HEADER_NAME] || '';
  const headerValueStr = Array.isArray(headerValue)
    ? headerValue.join(FLAG_DELIMITER)
    : headerValue;

  return headerValueStr.replaceAll(/, /g, FLAG_DELIMITER);
};

interface GetFeatureFlagsOptions {
  collapseFlagNames?: ObjectPropertyNameMatcher[];
}

export const getFeatureFlags = (
  req: IncomingMessage,
  { collapseFlagNames = [] }: GetFeatureFlagsOptions = {},
): Record<string, string> => {
  const headerValue = getFlagsHttpHeaderValue(req);
  const allFlags = parseFeatureFlagsString(headerValue);
  const collapseFlags = collapseFlagNames.length > 0;

  if (collapseFlags) {
    return cloneObjectWithCollapsingProperties(allFlags, collapseFlagNames);
  }

  return allFlags;
};
